export const loginUrl = window?.["loginUrl"] ?? "";
export const getTokenUrl = window?.["getTokenUrl"] ?? "";
export const contextPath = window?.["contextPath"] ?? "";
export const getJwtToken = (): string => {
  const token = window?.["token"];
  return token?._jwt ?? "";
};
